
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'CodeBlockFolder',
  data(): { open: boolean } {
    return { open: false };
  },
  props: {
    title: {
      type: String,
      default: 'Code Block'
    }
  },
  methods: {
    setOpen(open: boolean = true) {
      this.open = open;
    }
  }
});
